import { Icon } from '@leroy-merlin-br/backyard-react'
import { LeroyLogo } from '@leroy-merlin-br/backyard-icons'
import { ChevronDown, CrossOutline } from '@backyard-ui/icons'

import Button from './Button'
import { HeaderProps } from './types'
import * as S from './styled'

const Header = ({ onClose, onHide }: HeaderProps) => {
  return (
    <S.Header>
      <S.HeaderTitle data-testid="title">
        <S.HeaderLogo>
          <Icon as={LeroyLogo} />
        </S.HeaderLogo>
        <span> Assistente virtual</span>
      </S.HeaderTitle>
      <S.HeaderButtons data-testid="title-buttons">
        <Button
          data-testid="chat-hide-button"
          icon={ChevronDown}
          onClick={onHide}
        />
        <Button
          data-testid="chat-close-button"
          icon={CrossOutline}
          onClick={onClose}
        />
      </S.HeaderButtons>
    </S.Header>
  )
}

export default Header
